<template>
  <page-wrapper :title="pageWrapper.title" :hasPad="pageWrapper.hasPad">
    <div>
      <p class="category">{{ targeting.category }}</p>
      {{ targeting.detail ? targeting.detail : "-" }}
    </div>
    <div class="row">
      <div class="col-4 contact">
        <div class="row" style="align-items: center;">
          <p class="title">สถานะ Targeting :</p>
          <p class="ml-2" :class="targetingStatusClassList(targeting.status)">
            {{ targeting.statusName }}
          </p>
        </div>
        <div class="row mt-2">
          <p class="title">ผู้ชี้เป้า :</p>
          <p class="ml-2">{{ targeting.targetingAdminFullName }}</p>
        </div>
      </div>
      <div class="col-4 contact">
        <div class="row">
          <p class="title">วันที่ชี้เป้า :</p>
          <p class="ml-2">{{ displayDateFormat(targeting.estimatedPurchaseAt) }}</p>
        </div>
        <div class="row mt-2">
          <p class="title">ผู้รับผิดชอบการขาย :</p>
          <p class="ml-2">
            {{ targeting.agentAdminFullName }}
          </p>
        </div>
      </div>
      <div class="col-4 contact">
        <div class="row">
          <p class="title">วันหมดอายุ :</p>
          <p class="ml-2">{{ displayDateFormat(targeting.expiredAt) }}</p>
        </div>
      </div>
    </div>
    <div class="content mt-3">
      <div class="info-top home">
        <div class="content-header">รายละเอียดบ้าน</div>
        <div class="p-3">
          <div class="address-no">
            <p class="title">บ้านเลขที่</p>
            <p class="value">{{ user.addressNo }}</p>
          </div>
          <p class="title mt-2">Home ID : {{ user.homeId }}</p>
          <p>{{ user.projectName }}</p>
          <p class="title mt-2">พื้นที่ใช้สอย :</p>
          <p>{{ user.useableArea }}</p>
          <p class="title mt-2">อายุบ้าน :</p>
          <p>{{ user.homeAge }}</p>
          <sc-button
            variant="warning"
            class="mt-3"
            @click="handleLinkSubscriptionPurchasedHome()"
            >แพ็คเกจทั้งหมดของบ้าน
          </sc-button>
        </div>
      </div>
      <div class="info-top customer">
        <div class="content-header">ข้อมูลลูกค้า</div>
        <div class="user-detail p-3">
          <div>
            <img :src="defaultUserIcon" class="image" alt />
          </div>
          <div>
            <p class="full-name">
              {{ user.name }}
            </p>
            <div class="row">
              <div class="col-6">
                <p class="title">เบอร์โทร</p>
                <p>{{ user.mobileNumber }}</p>
              </div>
              <div class="col-6">
                <p class="title">อีเมล</p>
                <p>{{ user.email }}</p>
              </div>
            </div>
            <div class="mt-2">
              <p class="title">สถานะการยืนยันตัวตน</p>
              <p style="color: #0DBB6C;">
                {{ "ยืนยันแล้ว" }}
              </p>
            </div>
            <div class="mt-2">
              <p class="title">สถานะการเปิด Wallet</p>
              <p :class="walletStatusClassList(user.has_wallet)">
                {{ user.walletStatusText }}
              </p>
            </div>
            <div class="row mt-3">
              <div class="col-6 pr-1">
                <p class="title">
                  สถานะหลังการติดต่อชี้เป้า
                  <span style="color: red;" v-if="!isPermissionManager">*</span>
                </p>
                <p v-if="isPermissionManager">
                  {{ targeting.status ? targeting.statusName : "-" }}
                </p>
                <div v-else>
                  <el-select
                    style="width: 100%;"
                    v-model="value.statusTargeting"
                    clearable
                  >
                    <el-option
                      v-for="group in selectTargetingStatusOptions"
                      :key="group.id"
                      :value="group.id"
                      :label="group.name"
                    />
                  </el-select>
                  <p
                    v-if="statusTargetingError"
                    style="
                      color: red;
                      font-size: 12px;
                      margin-top: 5px;
                      margin-bottom: 0;
                    "
                  >
                    {{ statusTargetingError }}
                  </p>
                </div>
              </div>
              <div v-if="displayActionDetail" class="col-6 pl-1">
                <p class="title">เหตุผลที่ไม่ซื้อ</p>
                <p v-if="isPermissionManager">
                  {{ targeting.detail ? targeting.detail : "-" }}
                </p>
                <el-input v-else v-model="value.reason"/>
              </div>
            </div>
            <el-divider />
            <h5>ใบเสนอราคา</h5>
            <div class="row mt-2">
              <div class="col-4 pr-1">
                <p class="title">เลขที่ Quotation</p>
                <p v-if="isPermissionManager">
                  {{ quotation.refCode ? quotation.refCode : "-" }}
                </p>
                <div v-else>
                  <el-input
                    v-model="value.quotationNo"
                    class="mt-1"
                  />
                  <p
                    v-if="quotationNoError"
                    style="
                      color: red;
                      font-size: 12px;
                      margin-top: 5px;
                      margin-bottom: 0;
                    "
                  >
                    {{ quotationNoError }}
                  </p>
                </div>
              </div>
              <div class="col-4 pl-1 pr-1">
                <p class="title">วันที่ออก Quotation</p>
                <p v-if="isPermissionManager">
                  {{ quotation.createdAt ? displayDateFormat(quotation.createdAt) : "-" }}
                </p>
                <div v-else>
                  <el-date-picker
                    v-model="value.quotationCreatedAt"
                    class="mt-1 w-100"
                    value-format="yyyy-MM-dd"
                  />
                  <p
                    v-if="quotationCreatedAtError"
                    style="
                      color: red;
                      font-size: 12px;
                      margin-top: 5px;
                      margin-bottom: 0;
                    "
                  >
                    {{ quotationCreatedAtError }}
                  </p>
                </div>
              </div>
              <div class="col-4 pl-1">
                <p class="title">มูลค่า Quotation</p>
                <div v-if="isPermissionManager">
                  {{ quotation.price ? quotationPrice : "-" }}
                </div>
                <div v-else>
                  <el-input
                    v-model="value.quotationPrice"
                    class="mt-1"
                    type="number"
                 />
                  <p
                    v-if="quotationPriceError"
                    style="color: red; font-size: 12px; margin-top: 5px; margin-bottom: 0;"
                  >
                    {{ quotationPriceError }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p class="title">หมายเหตุ</p>
                <p v-if="isPermissionManager">
                  {{ quotation.remark ? quotation.remark : "-" }}
                </p>
                <el-input
                  v-else
                  type="textarea"
                  :rows="6"
                  style="width: 100%;"
                  v-model="value.remark"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p class="title">Referrals URL</p>
                <el-input
                  v-if="!isPermissionManager"
                  class="mb-3"
                  v-model="value.referralUrl"
                />
                <p v-if="quotation.referrals && quotation.referrals.length > 0">
                  <span
                    v-for="(ref, index) in quotation.referrals"
                    :key="ref.id"
                  >
                    <a
                      :href="`/ruejai-referral/admin/referrals/${ref.id}`"
                      class="text-primary"
                      target="_blank"
                    >
                      {{ ref.code }}
                    </a>
                    <span v-if="index < quotation.referrals.length - 1">,</span>
                  </span>
                </p>
                <p class="mt-3" v-else-if="isPermissionManager">-</p>
              </div>
            </div>
            <sc-button
              v-if="!isPermissionManager"
              @click="handleClickAddReferral()"
              class="mt-3"
              variant="warning"
              >สร้าง Referral ใหม่
            </sc-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 text-right">
      <div v-if="!isPermissionManager">
        <sc-button variant="primary" @click="submitForm">บันทึก </sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "../../../lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { DateTime } from "luxon";
import { permissionRole } from "@/lib/mapper";
import { toLocaleTH } from "@/lib/dateTime";
import {
  convertBathToStangAndRoundTwoDecimal,
  formatCurrencyAndTwoDecimalsString,
  roundToTwoAndMultiplyOneHundred
} from "@/lib/formatter";

export default {
  components: {
    PageWrapper,
    ScButton,
  },
  data() {
    const pageWrapper = {
      title: "รายละเอียด Targeting",
      hasPad: true
    };
    const permission =
      JSON.parse(localStorage.getItem("adminRolePermission")) || {};
    const targetingStatusOptions = [
      { id: "ACTIVE", name: "รอติดต่อ" },
      { id: "FOLLOW_UP", name: "รอติดตาม" },
      { id: "PURCHASED", name: "ซื้อแล้ว" },
      { id: "NOT_PURCHASE", name: "ไม่ซื้อ" },
      { id: "EXPIRED", name: "หมดอายุ" }
    ];

    return {
      pageWrapper,
      defaultUserIcon: "/static/icons/user-profile-default.png",
      isPermissionManager: permission.role === permissionRole.LMM,
      isPermissionCallCenter: permission.role === permissionRole.LMC || permission.role === permissionRole.LMA,
      value: {
        reason: null,
        quotationPrice: null,
        statusTargeting: null,
        remark: null,
        quotationNo: null,
        referralUrl: null,
        quotationCreatedAt: null
      },
      targetingStatusOptions,
      selectTargetingStatusOptions: targetingStatusOptions.filter(
        item => item.id === "FOLLOW_UP" || item.id === "PURCHASED" || item.id === "NOT_PURCHASE"
      ),
      quotation: {},
      user: {},
      targeting: {},
      selectedStatus: "",
      statusTargetingError: "",
      quotationNoError: "",
      quotationCreatedAtError: "",
      quotationPriceError: "",
      walletStatusText: ""
    };
  },
  computed: {
    homeId() {
      return this.home && this.home.homeId ? this.home.homeId : null;
    },
    quotationPrice() {
      return this.quotation.price
        ? formatCurrencyAndTwoDecimalsString(
          this.quotation.price
        )
        : "-";
    },
    displayActionDetail() {
      return this.value.statusTargeting === "NOT_PURCHASE"
    } 
  },
  created() {
    this.setupData();
  },
  methods: {
    async setupData() {
      await this.setupTargeting();
    },
    targetingId() {
      return this.$route.params.targetingId;
    },
    async setupTargeting() {
      try {
        const response = await this.fetchTargeting();

        this.targeting = this.setupTargetingDetail(response.data.result);
        this.user = this.setupUserDetail(response.data.result.user);
        this.quotation = this.setupQuotationDetail(
          response.data.result.quotation_referral
        );
      } catch (error) {
        const message = error.response
            ? error.response.data.message
            : error.message;

        alert(message);

        console.error(error);
      }
    },
    setupTargetingDetail(targeting) {
      const targetingAction = targeting.targeting_actions.find(action => action.status === "ACTIVE");
      const lastAction = targeting.targeting_actions[targeting.targeting_actions.length - 1];

      const targetingDetail = {
        category: targeting.category,
        targetingServiceId: targeting.targeting_service_id,
        targetingAdminFullName: targeting.targeting_admin_full_name,
        agentAdminFullName: targeting.agent_admin_full_name,
        estimatedPurchaseAt: lastAction.estimated_purchase_at,
        actions: targeting.targeting_actions,
        expiredAt: lastAction.expired_at,
        status: lastAction.status,
        statusName: this.targetingStatusOptions.find(
          item => item.id === lastAction.status
        ).name,
        detail: targetingAction && targetingAction.detail
          ? targetingAction.detail
          : null
      };

      this.value.statusTargeting = targetingDetail.status
        && targetingDetail.status !== "ACTIVE"
        && targetingDetail.status !== "EXPIRED"
          ? targetingDetail.status
          : null;

      if (lastAction.status === "NOT_PURCHASE") {
        this.value.reason = lastAction.detail
          ? lastAction.detail
          : null;
      }

      return targetingDetail;
    },
    setupUserDetail(user) {
      const userDetail = {
        name: user.full_name,
        email: user.email,
        mobileNumber: user.mobile_number,
        walletStatusText: user.has_wallet ? "เปิดแล้ว" : "ยังไม่ได้เปิด",
        homeId: user.home_id,
        projectName: user.project_name,
        addressNo: user.address_no,
        useableArea: user.useable_area,
        homeAge: user.home_age
      };

      return userDetail;
    },
    setupQuotationDetail(quotation) {
      const price = quotation.price
        ? convertBathToStangAndRoundTwoDecimal(quotation.price)
        : null;

      const quotationDetail = {
        refCode: quotation.ref_code,
        createdAt: quotation.created_at,
        price,
        remark: quotation.remark,
        referrals: quotation.referrals
      };

      this.value.quotationNo = quotationDetail.refCode
        ? quotationDetail.refCode
        : null;
      this.value.quotationPrice = quotationDetail.price
        ? quotationDetail.price
        : null;
      this.value.quotationCreatedAt = quotationDetail.createdAt
        ? quotationDetail.createdAt
        : null;
      this.value.remark = quotationDetail.remark
        ? quotationDetail.remark
        : null;

      return quotationDetail;
    },
    async fetchTargeting() {
      return await baanRueJaiClient.admin.lead.getTargetingDetail(
        this.targetingId()
      );
    },
    handleLinkSubscriptionPurchasedHome() {
      const homeId = this.user.homeId;
      this.$router.push({ name: "SubscriberListPage", query: { homeId } });
    },
    async submitForm() {
      this.statusTargetingError = "";
      this.quotationNoError = "";
      this.quotationCreatedAtError = "";
      this.quotationPriceError = "";

      let hasError = false;
      const hasQuotationInfo = this.value.referralUrl || this.value.quotationNo;

      if (!this.value.statusTargeting) {
        this.statusTargetingError = "กรุณาเลือก Status Targeting";
        this.errorMessage = "กรุณาเลือก Status Targeting";
        hasError = true;
      }

      if (this.value.referralUrl && !this.value.quotationNo) {
        this.quotationNoError = "กรุณากรอกเลขที่ Quotation";
        hasError = true;
      }

      if (hasQuotationInfo && !this.value.quotationCreatedAt) {
        this.quotationCreatedAtError = "กรุณาเลือกวันที่ออก Quotation";
        hasError = true;
      }

      if (hasQuotationInfo && !this.value.quotationPrice) {
        this.quotationPriceError = "กรุณากรอกจํานวนเงิน Quotation";
        hasError = true;
      }

      if (hasError) {
        return;
      }

      this.value.quotationCreatedAt =
        this.value.quotationCreatedAt === null ||
        this.quotation.createdAt === this.value.quotationCreatedAt
          ? this.quotation.createdAt
          : DateTime.fromFormat(this.value.quotationCreatedAt, "yyyy-MM-dd", {
              zone: "utc"
            }).toISO();
      await this.createTargeting();
    },
    async createTargeting() {
      const params = {
        targeting_service_id: this.targeting.targetingServiceId,
        estimated_purchase_at: this.targeting.estimatedPurchaseAt,
        action_status: this.value.statusTargeting,
        action_detail: this.value.reason,
        quotation_ref_code: this.value.quotationNo,
        quotation_price: roundToTwoAndMultiplyOneHundred(
          this.value.quotationPrice
        ),
        quotation_created_at: this.value.quotationCreatedAt,
        quotation_remark: this.value.remark,
        referral_url: this.value.referralUrl
      };
      
      try {
        await baanRueJaiClient.admin.lead.createTargeting(params);

        window.location.reload();
      } catch (error) {
        const message = error.response
          ? error.response.data.message
          : error.message;
        alert(message);
      }
    },
    handleClickAddReferral() {
      const newRouteUrl = this.$router.resolve({
        path: "/ruejai-referral/admin/referrals/create"
      });
      window.open(newRouteUrl.href, "_blank");
    },
    dateTimeTH(dateTime) {
      return toLocaleTH(DateTime.fromISO(dateTime)).toFormat("dd/MM/yyyy");
    },
    targetingStatusClassList(status) {
      if (!status) {
        return ["targeting-status"];
      }

      return ["targeting-status", status.toLowerCase()];
    },
    walletStatusClassList(hasWallet) {
      return ["wallet-status", hasWallet ? "active" : "inactive"];
    },
    displayDateFormat(dateTime) {
      return dateTime
        ? this.dateTimeTH(dateTime)
        : null;
    },
  },
  watch: {
    "value.statusTargeting"(newValue) {
      if (newValue) {
        this.statusTargetingError = "";
      }
    },
    "value.quotationNo"(newValue) {
      if (newValue && this.quotationNoError) {
        this.quotationNoError = "";
      }
    },
    "value.referralNo"(newValue) {
      if (!newValue) {
        this.quotationNoError = "";
        this.quotationCreatedAtError = "";
        this.quotationPriceError = "";
      }
    },
    "value.quotationCreatedAt"(newValue) {
      if (newValue && this.quotationCreatedAtError) {
        this.quotationCreatedAtError = "";
      }
    },
    "value.quotationAmount"(newValue) {
      if (newValue && this.quotationPriceError) {
        this.quotationPriceError = "";
      }
    },
    "value.reason"(newValue) {
      if (newValue && this.reasonError) {
        this.reasonError = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
@import "../lead";

.category {
  font-size: 24px;
  font-weight: bold;
}

.targeting-status {
  font-size: 14px;
  border-radius: 4px;
  text-align: center;
  color: $white;
  padding: 4px 12px;

  &.active {
    background-color: #2196F3;
  }

  &.follow_up {
    background-color: #FF9800;
  }

  &.purchased {
    background-color: #4CAF50;
  }

  &.not_purchase {
    background-color: #F44336;
  }

  &.expired {
    background-color: #9E9E9E;
  }
}

.contact {
  padding: 12px 30px;

  p {
    font-size: 14px;
  }

  .title {
    font-weight: bold;
  }
}

.info-top {
  border: 0.5px solid #d6d6d6;

  &.home {
    border-top-left-radius: $border-radius;
  }

  &.customer {
    border-top-right-radius: $border-radius;
  }
}

.content {
  display: grid;
  grid-template-columns: 300px auto;

  p {
    font-size: 14px;
    color: #4A4A4A;
  }

  .title {
    font-weight: bold;
    color: #2E2E2E
  }
}

.content-header {
  background: #cecdcd 0% 0% no-repeat padding-box;
  border-bottom: 1px solid #d6d6d6;
  opacity: 1;
  height: 58px;
  font-size: 17px;
  font-weight: bold;
  padding: 15px 10px;
}

.address-no {
  .title {
    font-size: 14px;
    color: #808080;
  }

  .value {
    font-size: 24px;
    font-weight: bold;
    color: black;
  }
}

.user-detail {
  display: grid;
  grid-template-columns: 56px max-content;
  grid-gap: 16px;

  .image {
    width: 56px;
    height: 56px;
    border-radius: 4px;
    border: solid 1px $white;
  }

  .full-name {
    font-size: 20px;
    font-weight: bold;
  }

  .wallet-status {
    &.active {
      color: #0DBB6C;
    }

    &.inactive {
      color: #FE676F;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/lead-management/pages/LeadManagementTargetingPage.vue